import React from 'react';
import {Platform} from 'react-native';
import WebView from 'react-native-webview';

import {mobileWebView3DsBrowserDataHtml} from '../util/threeDS';

type ThreeDsMobileBrowserDataIframeProps = {
  mobileWebView3DsBrowserDataJS: string;
  onBrowserData: (browserData: any) => void;
};
const ThreeDsMobileBrowserDataIframe = ({
  mobileWebView3DsBrowserDataJS,
  onBrowserData,
}: ThreeDsMobileBrowserDataIframeProps) => {
  if (Platform.OS === 'web') return <></>;
  if (!mobileWebView3DsBrowserDataJS) return <></>;

  return (
    <WebView
      source={{
        html: mobileWebView3DsBrowserDataHtml,
      }}
      injectedJavaScript={mobileWebView3DsBrowserDataJS}
      onMessage={event => {
        const browserDataMsg = JSON.parse(event?.nativeEvent?.data || '{}');
        if (browserDataMsg.type === '3ds-browser-data') {
          onBrowserData(browserDataMsg.payload);
        }
      }}
    />
  );
};

export default ThreeDsMobileBrowserDataIframe;
